import { createContext } from "react";
import { VisibilityContextType } from "../types";

export const VisibilityModeCtx = createContext<VisibilityContextType>({
    visibilityMode: null,
    setVisibilityMode: () => {}, 
});